<template>
  <div>
    <input
    type="text"
    :placeholder="placeholder"
    @input="$emit('input',{value: $event.target.value})"
    :value="value"
    :required="required === false ? false : true" />
  </div>
</template>

<script>
export default {
  computed: {
    value () {
      return this.$store.state.userData[this.dataKey]
    }
  },
  props: ['options', 'data-key', 'placeholder', 'required']
}
</script>
